exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1LfgbnXywy0yyfKPIanQ7Q{display:-webkit-box;display:-ms-flexbox;display:flex}", ""]);
// Exports
exports.locals = {
	"groupFacepile": "_1LfgbnXywy0yyfKPIanQ7Q"
};